<template>
  <CRow class="align-items-center my-3">
    <CCol sm="1" class="pr-4 pt-2"><CIcon :name="icon" size="custom-size" :height="setIconSize()" viewBox="0 0 32 32" /></CCol>
    <CCol sm="10">
      <CRow>
        <CCol class="font-weight-bold">{{ title }}</CCol>
      </CRow>
      <CRow>
        <CCol class="text-gray-400">{{ value }}</CCol>
      </CRow>
    </CCol>
  </CRow>
</template>
<script>
const iconSizeEnum = {
  sm: '20',
  md: '24',
  lg: '30',
}

export default {
  props: {
    icon: {
      type: String,
    },
    iconSize: {
      type: String,
      default: () => 'md',
    },
    title: {
      type: String,
      default: () => '',
    },
    value: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    setIconSize() {
      return iconSizeEnum[this.iconSize]
    },
  },
}
</script>
